/* eslint-disable */
export default {
  en: 'englanti',
  ja: 'japani',
  fr: 'ranska',
  de: 'saksa',
  es: 'espanja',
  it: 'italia',
  pt: 'portugali',
  zh: 'kiina',
  nl: 'hollanti',
  ko: 'korea',
  fi: 'suomi',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
